import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import { Col, Container, Row } from "react-bootstrap";
import { GetAllVendorsByStore, DeleteVendor } from "../../api";
import { Header, Button } from "../../components";
import "../../styles/viewCustomer.css";
import { useStateContext } from "../../contexts/ContextProvider";
import { usePromiseTracker, trackPromise } from "react-promise-tracker";
import {
  showSuccessToast,
  showErrorToast,
  showInfoToast,
} from "../../components/ToastMesg";
import DataGrid from "../../components/DataGrid";

const Vendor = () => {
  const navigate = useNavigate();
  const { storeG, userPermID } = useStateContext();
  const [AllVendors, setAllVendors] = useState("");
  const [Vendor_id, setVendor_id] = useState("");
  const { promiseInProgress } = usePromiseTracker();
  const [loading, setloading] = useState(false);

  const vendorsGrid = [
    {
      headerText: "Name",
      minWidth: "180",
      width: "320",
      maxWidth: "640",
      textAlign: "left",
      field: "name",
    },
    {
      field: "phone",
      headerText: "Phone",
      minWidth: "140",
      width: "180",
      maxWidth: "220",
      textAlign: "Center",
    },
    {
      field: "website",
      headerText: "Website",
      minWidth: "140",
      width: "150",
      maxWidth: "210",
      textAlign: "left",
    },
    {
      field: "term",
      headerText: "Terms",
      minWidth: "140",
      width: "150",
      maxWidth: "210",
      textAlign: "left",
    },
    {
      field: "contact_name",
      headerText: "Contact Name",
      minWidth: "180",
      width: "250",
      maxWidth: "320",
      textAlign: "left",
    },
    {
      field: "balance",
      headerText: "Balance",
      minWidth: "125",
      width: "140",
      maxWidth: "150",
      format: "C2",
      textAlign: "right",
    },
  ];

  const handleAddVendorClick = async (event) => {
    event.preventDefault();
    TimeoutUtility.resetTimeout();
    navigate(`/Vendor/AddVendor`, {
      state: { fromPage: "Vendor" },
    });
  };

  const handleEditVendorClick = async (event) => {
    event.preventDefault();
    TimeoutUtility.resetTimeout();
    if (Vendor_id !== "") navigate(`/Vendor/EditVendor/${Vendor_id}`);
    else showInfoToast("Info!", "Please select vendor to edit!");
  };

  const handleDeleteVendorClick = async (event) => {
    event.preventDefault();
    TimeoutUtility.resetTimeout();
    try {
      if (Vendor_id !== "") {
        if (window.confirm(`Are you sure you want to Delete this vendor?`)) {
          const response = await DeleteVendor(Vendor_id);
          if (response.success) {
            showSuccessToast("Success!", "Vendor deleted successfully.");
            window.location.reload();
          } else
            showErrorToast(
              "Error!",
              "Vendor failed to delete: " + response.message,
            );
        }
      } else showInfoToast("Info!", "Please select vendor to delete!");
    } catch (error) {
      showErrorToast("Error!", "Vendor failed to delete!");
    }
  };

  const handleViewVendorClick = async () => {
    TimeoutUtility.resetTimeout();
    if (Vendor_id !== "") navigate(`/Vendor/ViewVendor/${Vendor_id}`);
    else showInfoToast("Info!", "Please select vendor to view.");
  };

  const handleRowSelected = (args) => setVendor_id(args.data.vendor_id);

  const handleRefresh = async () => {
    if (storeG?.store_id) {
      const resp = await GetAllVendorsByStore(storeG.store_id);
      setAllVendors(resp.data || []);
    }
  };

  useEffect(() => {
    async function fetchData() {
      if (storeG?.store_id) {
        setloading(true);
        trackPromise(
          GetAllVendorsByStore(storeG.store_id)
            .then((result) => setAllVendors(result.data || []))
            .catch((err) => console.log(err.message))
            .finally(() => setloading(false)),
        );
      }
    }
    fetchData();
  }, [storeG]);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 main-div-bg">
      <Header category="Accounts" title="VENDORS" />
      <Container fluid className="g-0 p-0 justify-end">
        <Row xs={2} className="button-row justify-content-end font-normal">
          {userPermID.includes(15) && (
            <Col md="auto p-0">
              <Button text="Add" onClick={handleAddVendorClick} />
            </Col>
          )}
          {userPermID.includes(16) && (
            <>
              <Col md="auto p-0">
                <Button text="Update" onClick={handleEditVendorClick} />
              </Col>
              <Col md="auto p-0">
                <Button text="Delete" onClick={handleDeleteVendorClick} />
              </Col>
            </>
          )}
        </Row>
      </Container>
      <DataGrid
        loading={loading || promiseInProgress}
        data={AllVendors}
        cols={vendorsGrid}
        handleRowSelected={handleRowSelected}
        handleDoubleClick={userPermID.includes(14) && handleViewVendorClick}
        persistant={true}
        handleRefresh={handleRefresh}
      />
    </div>
  );
};

export default Vendor;
